import { Component,  OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-comentario-incidencia',
    templateUrl: './comentario-incidencia.component.html',
    styleUrls: ['./comentario-incidencia.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatSelectionList, NgFor, MatListOption, MatButton]
})
export class ComentarioIncidenciaComponent implements OnInit {
  totalsize = 0;
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  esCometario: boolean = false;
  formRegistro: FormGroup;

  constructor( public dialogRef: MatDialogRef<ComentarioIncidenciaComponent>, private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.formreg();
  }

 
  onNoClick(): void {
    this.dialogRef.close();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  subirEv() {
    const input = (<HTMLInputElement>document.getElementById('nameFile'));
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i])
      }
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }

  elimina() {
    for (let i = 0; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex(item => item.name == this.selectedOptions[i].name);
      this.evidencia.splice(this.index, 1);
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }
  onNgModelChange($event) {
    this.selectedOptions = $event;
    if (this.selectedOptions.length != 0) {
      this.btnElimina = false;
      this.btnAgrega = true;
    } else {
      this.btnElimina = true;
      this.btnAgrega = false;
    }
  }
  onSave(): void {
    this.dialogRef.close();
  }

  formreg() {
    this.formRegistro = this.formBuilder.group({
      Descripcion: ['', [Validators.required]]
    });
  }

}
